import PhonePylonIcon from '@motional/inguitiv/svg/icon/phone-pylon.svg?react';

function Icon() {
  return <PhonePylonIcon />;
}

export default Icon;
